import React, { createContext, useEffect, useState } from "react";

export const FormContext = createContext();

export const FormProvider = ({ type = "create", data, children }) => {
  const [formData, setFormData] = useState(data);
  const [rowsSelect, setRowsSelect] = useState([]);
  const [rowsSelectBarang, setRowsSelectBarang] = useState([]);
  const [rowsBarang, setRowsBarang] = useState([]);
  const [rowsRekomendasi, setRowsRekomendasi] = useState([]);
  const [listPO, setListPO] = useState([]);
  const [showModalHistory, setShowModalHistory] = useState(false);

  useEffect(() => {
    setFormData(data);
  }, [data]);

  return (
    <FormContext.Provider value={{ formData, setFormData, showModalHistory, setShowModalHistory, rowsSelect, setRowsSelect, listPO, setListPO, rowsBarang, setRowsBarang, rowsRekomendasi, setRowsRekomendasi, rowsSelectBarang, setRowsSelectBarang }}>
      {children}
    </FormContext.Provider>
  );
};
